import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Chip,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

import { useAuthStore } from "../store/authStore";

export function Profile() {
  const username = useAuthStore((state) => state.username);
  const provider = useAuthStore((state) => state.provider);
  const roles = useAuthStore((state) => state.roles);
  const canManageSettings = useAuthStore((state) => state.canManageSettings());
  const isLegalRestrictedUser = useAuthStore((state) => state.isLegalRestrictedUser());

  const effectiveRole = canManageSettings ? "amministratore" : (isLegalRestrictedUser ? "legal" : "operatore");
  const effectivePermissions = canManageSettings
    ? "Accesso completo: puo modificare impostazioni e funzioni critiche."
    : (isLegalRestrictedUser
      ? "Accesso legal: puo consultare solo Ricerca, Archivio e Profilo."
      : "Sola lettura: puo consultare dashboard, statistiche, archivio, ricerca, notifiche e attivita.");

  return (
    <Card>
      <CardHeader
        avatar={<PersonRoundedIcon color="primary" />}
        title="Profilo e Permessi"
        subheader="Ruolo e capacita applicative dell'utente autenticato"
      />
      <CardContent>
        <Stack spacing={2}>
          <List dense>
            <ListItem>
              <ListItemText primary="Utente" secondary={username || "-"} />
            </ListItem>
            <ListItem>
              <ListItemText primary="Provider autenticazione" secondary={provider} />
            </ListItem>
            <ListItem>
              <ListItemText primary="Ruolo effettivo" secondary={effectiveRole} />
            </ListItem>
          </List>

          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
            <Chip
              icon={<VerifiedUserRoundedIcon />}
              color={canManageSettings ? "success" : (isLegalRestrictedUser ? "info" : "warning")}
              label={canManageSettings ? "Accesso amministratore" : (isLegalRestrictedUser ? "Accesso legal" : "Accesso operatore")}
            />
            {roles.length > 0 ? (
              roles.map((role) => (
                <Chip key={role} icon={<ShieldRoundedIcon />} label={role} variant="outlined" />
              ))
            ) : (
              <Chip label="Nessun ruolo esplicito" variant="outlined" />
            )}
          </Stack>

          <Alert severity={canManageSettings ? "success" : "info"}>{effectivePermissions}</Alert>

          {!canManageSettings && !isLegalRestrictedUser ? (
            <Typography variant="body2" color="text.secondary">
              Le sezioni Impostazioni e Sviluppatori sono riservate al ruolo amministratore.
            </Typography>
          ) : null}
          {isLegalRestrictedUser ? (
            <Typography variant="body2" color="text.secondary">
              Il ruolo legal puo accedere solo alle sezioni Ricerca, Archivio e Profilo.
            </Typography>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
}
